import { connect } from 'react-redux'
import Montoring from 'components/Monitoring/monitoringList';
import {
    getMonitoringAlerts,
    getMonitoringConfigurationList,
    getMonitoringSummary,
    acknowledgeMonitoringAlert,
    acknowledgeMonitoringAlerts,
    addMonitoringAlertNote,
    hideMonitoringAlertNote,
    getMonitoringSeverityConfig,
    updateMonitoringSeverityConfig,
    getMonitoringFieldCatalog,
    getMonitoringWatchedFields,
    updateMonitoringWatchedFields,
    getMonitoringBusinesses,
    getMonitoringDevEnabled,
    createMonitoringTestAlert,
    runMonitoringNow,
    previewBulkMonitoring,
    applyBulkMonitoring,
    getMonitoringConfig,
    updateMonitoringConfig
} from 'actions/monitoring';

function mapStateToProps(stateProps) {
    const monitoringList = stateProps?.monitoring?.alertList || [];
    const monitoringConfigurationList = stateProps?.monitoring?.configurations?.data || [];
    const monitoringConfigurationHeaders = stateProps?.monitoring?.configurations?.headers || {};
    const monitoringSummary = stateProps?.monitoring?.summary || null;
    const monitoringAlertHeaders = stateProps?.monitoring?.alertHeaders || {};
    return {
        monitoringList,
        monitoringConfigurationList,
        monitoringConfigurationHeaders,
        monitoringSummary,
        monitoringAlertHeaders
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...stateProps,
        ...ownProps,
        ...dispatchProps,
    }
}

export default connect(
    mapStateToProps,
    {
        getMonitoringAlerts,
        getMonitoringConfigurationList,
        getMonitoringSummary,
        acknowledgeMonitoringAlert,
        acknowledgeMonitoringAlerts,
        addMonitoringAlertNote,
        hideMonitoringAlertNote,
        getMonitoringSeverityConfig,
        updateMonitoringSeverityConfig,
        getMonitoringFieldCatalog,
        getMonitoringWatchedFields,
        updateMonitoringWatchedFields,
        getMonitoringBusinesses,
        getMonitoringDevEnabled,
        createMonitoringTestAlert,
        runMonitoringNow,
        previewBulkMonitoring,
        applyBulkMonitoring,
        getMonitoringConfig,
        updateMonitoringConfig
    },
    mergeProps
)(Montoring)